import {HistoryListElementType} from "../interface";
import Detail from "./Detail";
import {Dispatch, SetStateAction, useRef} from "react";
import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";
import DisplayNumber from "../../../../components/common/number/DisplayNumber";

interface PropsType {
    history: HistoryListElementType[]
    fetch: any
    selectedHistoryIdx: number
    setSelectedHistoryIdx: Dispatch<SetStateAction<number>>
}

const invBoxTitle = (type: string) => {
    return <div className="inv_box_title">
        {type === "incoming" && <><img
            src={process.env.PUBLIC_URL + `/assets/images/icon_boxblue1.png`} alt=""/>입고</>}
        {type === "outgoing" && <><img
            src={process.env.PUBLIC_URL + `/assets/images/icon_boxblue.png`} alt=""/>출고</>}
        {type === "adjustment" && <><img
            src={process.env.PUBLIC_URL + `/assets/images/icon_boxblue2.png`} alt=""/>조정</>}
    </div>
}

export default function List({history, fetch, selectedHistoryIdx, setSelectedHistoryIdx}: PropsType) {

    const scrollRef = useRef<any>(null)

    useInfiniteScroll({ref: scrollRef, callback: fetch, options: {}})

    // TODO: 재고 내역 컨테이너 브라우저 최하단까지 채우게끔 변경해야됨
    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">재고 내역</h3>
            <div className="filter_toolbar"></div>
        </div>

        <div className="search_inv_section">
            {history.length !== 0
                ? <>
                    <div className="left">
                        {history.map((el, idx) =>
                            <div
                                className={`inv_box ${selectedHistoryIdx === idx ? "blue" : ""} clickable`}
                                onClick={() => setSelectedHistoryIdx(idx)}
                            >
                                <div className="inv_box_top">
                                    {invBoxTitle(el.changeType)}
                                    <div className="inv_box_toolbar">
                                        <div className="inv_box_time m-0">{el.changeAt}</div>
                                    </div>
                                </div>
                                <div className="inv_box_content">
                                    <div className="line1">{el.recordSize}품목 / <DisplayNumber value={el.totalChange}/>개
                                    </div>
                                    <div
                                        className="line2">{el.accountName && el.accountName.length !== 0 ? el.accountName : <>&nbsp;</>}</div>
                                    <div
                                        className="line3">{el.mainItemName && el.mainItemName.length !== 0 ? el.mainItemName : <>&nbsp;</>}</div>
                                </div>
                            </div>)}
                        <div style={{height: "1px"}} ref={scrollRef}></div>
                    </div>

                    <Detail historyDetail={
                        selectedHistoryIdx !== -1
                            ? history.at(selectedHistoryIdx)
                            : undefined
                    }/>
                </>
                // TODO: 조회 결과 없을 때 컨테이너 영역 크기 조절해야됨
                : <div className="d-flex justify-content-center align-items-center w-100">조회된 데이터가 없습니다.</div>
            }
        </div>
    </div>
}